import { useNotification } from '../../context/NotificationContext'

const Notification = () => {
  const { notification, hideNotification } = useNotification()

  if (!notification) return null

  const { message, type } = notification

  return (
    <div className={`alert alert-${type === 'success' ? 'success' : 'danger'} alert-dismissible fade show`}>
      {message}
      <button 
        type="button" 
        className="close" 
        onClick={hideNotification}
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  )
}

export default Notification
